import { View, StyleSheet, ActivityIndicator } from "react-native";
import { useTheme } from '@react-navigation/native';
import { useForm } from "react-hook-form";
import { useTranslation } from 'react-i18next';
import CustomLabel from "../../../../components/CustomLabel/CustomLabel";
import CustomButton from "../../../../components/CustomButton";
import HRAdminChangeEmplId from "./HRAdminChangeEmplId";
import { useHRAdminEmplAdvancedSettings } from "../../../../hooks/useHRAdminEmplAdvancedSettings";
import { createCommonStyles } from "../../../../styles/commonStyles";
import { CONTROL_FORM_FIELDS } from "../../../../constants/ControlFormFields";
import { showMessage } from 'react-native-flash-message';


const HRAdminAdvancedSettings = (props) => {
    const { colors } = useTheme();
    const common = createCommonStyles(colors);
    const { t } = useTranslation();
    const styles = makeStyles(colors);
    const { changeEmployeeId, isLoading } = useHRAdminEmplAdvancedSettings();
    const { EMPLOYEEIDINPUT } = CONTROL_FORM_FIELDS.CHANGEEMPLOYEEID;
    const {
        control,
        handleSubmit,
        formState: { errors },
        resetField
    } = useForm({
        defaultValues: {
            [EMPLOYEEIDINPUT]: "",
        },
        mode: "onBlur",
        reValidateMode: "onChange",
    });

    //* Has any Has AlL is a check for leter adv settings that are not only 1 input. To check that all fields required are set before creating the axios call to sent to API 
    //* Curently unused but as adv settings are populated they will be needed. 
    const hasAny = (fields) => fields.some((f) => data[f]);
    const hasAll = (fields) => fields.every((f) => data[f]);

    const onSubmit = async (data) => {
        const calls = [];
        if (data[EMPLOYEEIDINPUT]) {
            calls.push(changeEmployeeId(props?.selectedEmployee?.employeeID, data[EMPLOYEEIDINPUT], props.selectedEmployee?.name)
                .then((res) => ({ success: true, res }))
                .catch((err) => ({ success: false, err, call: "updateEmployeeId" })))
        }

        var results = await Promise.allSettled(calls);

        results.forEach((result) => {
            let res = result.value;
            if (!res.success) {
                resetField(EMPLOYEEIDINPUT);
                // console.error(`${res.call} failed:`, t(`common:${res.err.response.data}`));
                showMessage({
                    message: t(`common:${res.err.response.data}`),
                    type: "danger",
                    duration: 3000,
                });
            }
            else {
                showMessage({
                    message: t(`common:emplIdSucc`),
                    type: "success",
                    duration: 3000,
                });
            }
        });
    };

    if (isLoading) {
        return (
            <View
                style={styles.mainView}>
                <ActivityIndicator animating={true} size='large' color="#86BC25" />
            </View>
        )
    }

    return (
        <View style={[styles.mainView]}>
            <View style={common.titleButtonRow}>
                <CustomLabel
                    value={t('navigate:advSettings')}
                    type='MINORTITLE'
                    fontSize={20}
                />
                {/* //* On Save button for all advanced settings - Promise queuse all axios post changes. */}
                <CustomButton
                    onPress={handleSubmit(onSubmit)}
                    text={t('common:save')}
                    iconName='save-outline'
                    show='BUTTON_SAVE'
                    type='BUTTON_SAVE'
                    isGradient={true}
                    textTop={0}
                    sz={20}
                />
            </View>
            <HRAdminChangeEmplId
                {...props}
                control={control} />
        </View>
    )
}

const makeStyles = (colors) =>
    StyleSheet.create({
        mainView: {
        },
    })

export default HRAdminAdvancedSettings;